import { useState, useEffect, useContext, useRef } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Skeleton } from 'primereact/skeleton';
import Button from '../../components/User/button';
import WishListIcon from '../../components/Common/wishListIcon';
//import SimilarProductCarousel from '../../components/Common/SimilarProduct';
import Card from '../../components/Common/Card';
import QuickViewDialog from "../../components/Common/QuickViewDialog";
import { useCount } from "../../context/CountContext";
import AuthContext from '../../context/AuthContext';
import useCartHandler from '../../utils/HandleCart';
import { StyleJewelleryDetailData, TransferBasket, GetBasketData, ShareProductData } from '../../api/styleJewelleryService';
import { LuMessageCircleWarning } from "react-icons/lu";
import { GrShareOption } from "react-icons/gr";
import PriceValue from "../../components/Common/PriceValue";
import { useAuth } from "../../context/AuthContext";
import "../../css/StyleJewellery/style_jewellery_detail.css";
import { Tooltip } from "primereact/tooltip";
import { Link } from "react-router-dom";
import CustomerSelection from "../../components/Common/CustomerSelection";
import { IoIosArrowRoundBack } from "react-icons/io";

const StyleJewelleryDetail = () => {
    document.title = "Style Inventory Detail | Meera Jewellery House Admin";
    const isTrue = (val) => ["YES", "TRUE", "1", "Y"].includes(String(val ?? "").toUpperCase());
    const { cartCount, wishlistCount, fetchWishlistCount, fetchStyleCartCount, setCartCount } = useCount();
    const { user, showToast } = useAuth();
    // #region FOR VARIABLE DECLARATION
    const { user: { LEDGER_ID: ledgerId } } = useContext(AuthContext);
    const [windowHeight, setWindowHeight] = useState(0);
    const [quantity, setQuantity] = useState(1);
    const { HandleCartInsert } = useCartHandler();
    const [isZoomVisible, setIsZoomVisible] = useState(false);
    const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });
    const [zoomStyles, setZoomStyles] = useState({
        backgroundImage: 'none',
        backgroundSize: 'auto',
        backgroundPosition: '0 0'
    });
    const [activeImageUrl, setActiveImageUrl] = useState("");
    const zoomPaneRef = useRef(null);
    const driftRef = useRef(null);
    const [showMediaModal, setShowMediaModal] = useState(false);
    const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
    const [mediaItems, setMediaItems] = useState([]);
    useEffect(() => {
        setWindowHeight(window.innerHeight);
    }, []);
    const [showModal, setShowModal] = useState(false);

    const handleShow = () => { setShowModal(true); };
    const handleClose = () => { setShowModal(false); };
    const [loading, setLoading] = useState(false);
    const [recentView, setRecentView] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const style_ID = queryParams.get("style_ID");
    const GoldQualityID = queryParams.get("GoldQualityID");
    const DiamondType_ID = queryParams.get("DiamondType_ID");
    const ProductSizeID = queryParams.get("ProductSizeID");
    const [JewelleryData, setJewelleryData] = useState(null);
    const [JewelleryColor, setJewelleryColor] = useState(null);
    const [selectedProductSize, setSelectedProductSize] = useState(ProductSizeID ?? "");
    const [selectedMetal, setSelectedMetal] = useState(GoldQualityID ?? "");
    const [selectedQuality, setSelectedQuality] = useState("");
    const [selectedColor, setSelectedColor] = useState("");
    const [jewelleryVideo, setJewelleryVideo] = useState([]);
    const [selectedDiamondTypeId, setSelectedDiamondTypeId] = useState(DiamondType_ID ?? "");
    const [product, setProduct] = useState(null);
    const [productItem, setProductItem] = useState(null);
    const [collectionDetail, setCollectionDetail] = useState([]);
    const [materials, setMaterials] = useState([]);

    const [isParaLoading, setIsParaLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [selectedProductQuickView, setSelectedProductQuickView] = useState(null);
    const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        if (style_ID) fetchDiamondDetail();
    }, [style_ID, user?.SelectedCustomer_ID, ledgerId, location.key]);

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            fetchDiamondDetail();
        }, 300);
    }, [refreshTrigger]);

    useEffect(() => {
        setRefreshTrigger(prev => prev + 1);
    }, [selectedProductSize, selectedMetal, selectedDiamondTypeId, selectedQuality, selectedColor, user?.SelectedCustomer_ID]);

    useEffect(() => {
        if (user?.SelectedCustomer_ID) {
            fetchWishlistCount(user.SelectedCustomer_ID);
            fetchStyleCartCount(user.SelectedCustomer_ID);
        }
    }, [user?.SelectedCustomer_ID]);

    //useEffect(() => {
    //    fetchSimilarProduct();
    //}, [ledgerId, style_ID]);

    const addToRecentViews = (product) => {
        let recent = JSON.parse(localStorage.getItem("recentViews")) || [];
        recent = recent.filter((p) => p.style_ID !== product.style_ID);
        recent.unshift(product);
        localStorage.setItem("recentViews", JSON.stringify(recent.slice(0, 8)));
    };
    const fetchDiamondDetail = async () => {
        try {
            setLoading(true);
            setIsParaLoading(true);

            const requestParameter = JSON.stringify({
                Party_ID: user?.SelectedCustomer_ID || "0",
                Style_ID: style_ID,
                StockCategory: "STYLE",
                PageNo: "1",
                PageSize: "50",
            });

            const response = await StyleJewelleryDetailData(requestParameter);
            const apiData = response?.data ?? response;

            const productItem = apiData?.Products?.[0];
            setProductItem(productItem);
            setJewelleryData(productItem);
            const materialDetails = apiData?.MaterialDetail ?? [];
            const CollectionDetails = apiData?.CollectionDetail ?? [];
            const firstMaterial = materialDetails?.[0] || {};

            if (!productItem) {
                throw new Error("Product not found");
            }

            const mappedProduct = {
                Shortdescription: productItem.Shortdescription,
                Style_ID: productItem.Style_ID,
                Status: productItem.Status || "",
                StockType: productItem.StockType,
                MetalQuality: productItem.MetalQuality,
                MetalTone: productItem.MetalTone,
                ItemSize: productItem.ItemSize,
                StoneQuality: productItem.StoneQuality,
                JewelCode: productItem.JewelCode,
                StyleNo: productItem.StyleNo,
                Category: productItem.Category,
                HallmarkNo: productItem.HallmarkNo,
                CertificateNo: productItem.CertificateNo,
                GrossWt: productItem.GrossWt,
                TotalNetWt: productItem.TotalNetWt,
                DiaWt: productItem.DiaWt,
                DiaPcs: productItem.DiaPcs,
                CDiaWt: productItem.CDiaWt,
                CDiaPcs: productItem.CDiaPcs,
                NewArrivalStatus: productItem.NewArrivalStatus,
                PriceRemark: productItem.PriceRemark,
                LineAmount: productItem.LineAmount,
                TotalAmount: productItem.TotalAmount,
                LineDiscount: productItem.LineDiscount,
                Line1: productItem.Line1,
                Wishlist_ID: productItem.Wishlist_ID,
                Cart_ID: productItem.Cart_ID,
                IS_AddedInWishlist: productItem.IS_AddedInWishlist,
                IS_AddedInCart: productItem.IS_AddedInCart,
                Quantity: productItem.Qty || productItem.Quantity || 0,
                Qty: productItem.Qty || productItem.Quantity || 0,

                MaterialMMSize: firstMaterial?.MaterialMMSize || "-",
                MaterialQuality: firstMaterial?.MaterialQuality || "-",

                images: [
                    productItem.Image1,
                    productItem.Image2,
                    productItem.Image3,
                    productItem.Image4,
                ].filter(Boolean),
            };

            let isInCart = isTrue(productItem.IS_AddedInCart);
            const isInEnquiry = isTrue(productItem.IS_AddedInEnquiry);
            const collectionDetails = apiData?.CollectionDetail || [];
            const colorData = apiData?.ColorDetail || [];

            const videoData = apiData?.VideoDetail || [];
            setJewelleryVideo(videoData);
            setJewelleryColor(colorData);
            setCollectionDetail(collectionDetails);
            setProduct(mappedProduct);
            setMaterials(materialDetails);
            addToRecentViews(mappedProduct);
        } catch (err) {
            console.error("Product detail error:", err);
            setProduct(null);
        } finally {
            setLoading(false);
            setIsParaLoading(false);
        }
    };

    // #endregion SIMILAR PRODUCT

    if (!product || Object.keys(product).length === 0) {
        return (
            <div className="StyleJewelleryDetail-container">
                <section className="vault-header-detail-card">
                    <div className="product-detail-header-left">
                        <h3 className="page-title">Style Inventory Detail</h3>
                    </div>
                    <div className="product-detail-header-right">
                        <div className="customer-wrapper">
                            <Skeleton width="220px" height="40px" borderRadius="8px" />
                        </div>
                        <div className="header-actions">
                            <Skeleton shape="circle" size="38px" />
                            <Skeleton shape="circle" size="38px" />
                        </div>
                        <button className="back-btn" onClick={() => navigate(-1)}>
                            <i className="pi pi-arrow-left"></i>
                        </button>
                    </div>
                </section>

                <section className="Vault-access-detail vault-header-card mt-3">
                    <div className="container-fluid">
                        <div className="row g-4 align-items-start">
                            <div className="col-lg-5 col-md-12">
                                <Skeleton width="100%" height="650px" borderRadius="20px" />
                            </div>
                            <div className="col-lg-7 col-md-12">
                                <div className="ps-lg-4">
                                    <Skeleton width="85%" height="3rem" className="mb-3" />
                                    <div className="d-flex justify-content-between align-items-center mb-5">
                                        <Skeleton width="40%" height="1.5rem" />
                                        <Skeleton width="25%" height="1.5rem" />
                                        <div className="d-flex gap-3">
                                            <Skeleton shape="circle" size="32px" />
                                            <Skeleton shape="circle" size="32px" />
                                        </div>
                                    </div>

                                    <div className="Details-section mb-5">
                                        <Skeleton width="150px" height="1.8rem" className="mb-4" />
                                        <div className="row g-4">
                                            {Array.from({ length: 6 }).map((_, i) => (
                                                <div key={i} className="col-6">
                                                    <Skeleton width="100%" height="1.2rem" />
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="action-buttons d-flex gap-3 mt-5">
                                        <Skeleton width="160px" height="50px" borderRadius="8px" />
                                        <Skeleton width="220px" height="50px" borderRadius="8px" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row g-4 mt-5 pt-5 border-top">
                            <div className="col-lg-6 col-md-12">
                                <div className="mb-5">
                                    <Skeleton width="180px" height="1.8rem" className="mb-4" />
                                    <Skeleton width="100%" height="1rem" className="mb-2" />
                                    <Skeleton width="100%" height="1rem" className="mb-2" />
                                    <Skeleton width="100%" height="1rem" className="mb-2" />
                                    <Skeleton width="70%" height="1rem" />
                                </div>
                                <div className="mb-4">
                                    <Skeleton width="220px" height="1.8rem" className="mb-4" />
                                    <Skeleton width="100%" height="150px" borderRadius="12px" />
                                </div>
                                <div className="mb-4">
                                    <Skeleton width="240px" height="1.8rem" className="mb-4" />
                                    <Skeleton width="100%" height="180px" borderRadius="12px" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <Skeleton width="100%" style={{ aspectRatio: '1/1' }} borderRadius="20px" />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    const handleUpdateCartID = (styleId, newCartID, newQty) => {
        setProduct((prev) => {
            if (!prev || prev.Style_ID !== styleId) return prev;
            return {
                ...prev,
                Cart_ID: newCartID,
                IS_AddedInCart: newCartID ? "YES" : "NO",
                Quantity: newQty !== undefined ? (isTrue(prev.IS_AddedInCart) ? (Number(prev.Quantity || 0) + Number(newQty)) : Number(newQty)) : prev.Quantity
            };
        });
        setProductItem((prev) => {
            if (!prev || prev.Style_ID !== styleId) return prev;
            return {
                ...prev,
                Cart_ID: newCartID,
                IS_AddedInCart: newCartID ? "YES" : "NO",
                Quantity: newQty !== undefined ? (isTrue(prev.IS_AddedInCart) ? (Number(prev.Quantity || 0) + Number(newQty)) : Number(newQty)) : prev.Quantity
            };
        });
    };

    const handleTransferUpdate = (styleId, newBasketID, target, newQty) => {
        const isToWishlist = target === 'wishlist';
        setProduct((prev) => {
            if (!prev || prev.Style_ID !== styleId) return prev;
            return {
                ...prev,
                Cart_ID: isToWishlist ? null : newBasketID,
                IS_AddedInCart: isToWishlist ? "NO" : "YES",
                Wishlist_ID: isToWishlist ? newBasketID : null,
                IS_AddedInWishlist: isToWishlist ? "YES" : "NO",
                Quantity: !isToWishlist && newQty !== undefined ? (isTrue(prev.IS_AddedInCart) ? (Number(prev.Quantity || 0) + Number(newQty)) : Number(newQty)) : prev.Quantity
            };
        });
        setProductItem((prev) => {
            if (!prev || prev.Style_ID !== styleId) return prev;
            return {
                ...prev,
                Cart_ID: isToWishlist ? null : newBasketID,
                IS_AddedInCart: isToWishlist ? "NO" : "YES",
                Wishlist_ID: isToWishlist ? newBasketID : null,
                IS_AddedInWishlist: isToWishlist ? "YES" : "NO",
                Quantity: !isToWishlist && newQty !== undefined ? (isTrue(prev.IS_AddedInCart) ? (Number(prev.Quantity || 0) + Number(newQty)) : Number(newQty)) : prev.Quantity
            };
        });
    };

    const handleAddToCart = async () => {
        if (!user?.SelectedCustomer_ID || user?.SelectedCustomer_ID === 0) {
            showToast({
                title: "Validation",
                message: "Please select a specific customer to add items to cart.",
                type: "warning",
            });
            return;
        }
        if (!product || Object.keys(product).length === 0) {
            console.log("Product not loaded yet");
            return;
        }
        if (isProcessing) return;
        setIsProcessing(true);
        const isInWishlist = isTrue(product.IS_AddedInWishlist);

        try {
            if (isInWishlist) {
                const response = await TransferBasket({
                    Party_ID: user?.SelectedCustomer_ID,
                    Style_ID: product.Style_ID
                });
                if (response?.Message?.[0]?.RETURNCODE === "1") {
                    const { RETURNMESSAGE, RETURNMESSAGETITLE } = response.Message[0];
                    const newCartID = response.InsertWishlist?.at(-1)?.Basket_ID || "TEMP_CART_ID";
                    handleTransferUpdate(product.Style_ID, newCartID, 'cart', Number(quantity));
                    fetchStyleCartCount(user?.SelectedCustomer_ID);
                    fetchWishlistCount(user?.SelectedCustomer_ID);
                    showToast({
                        title: RETURNMESSAGETITLE || "Success",
                        message: RETURNMESSAGE || "Item transferred to cart.",
                        type: "success"
                    });
                } else {
                    throw new Error(response?.Message?.[0]?.RETURNMESSAGE || "Transfer failed");
                }

            } else {
                const targetQty = Number(quantity);
                const result = await HandleCartInsert({
                    request: {
                        Party_ID: user?.SelectedCustomer_ID,
                        Style_ID: product.Style_ID,
                        JewelCode: product.JewelCode,
                        StyleNo: product.StyleNo,
                        Quantity: String(targetQty),
                        Rate: product.TotalAmount || "0",
                    }
                });

                if (result.success) {
                    handleUpdateCartID(product.Style_ID, result.newBasketID, targetQty);
                    fetchStyleCartCount(user?.SelectedCustomer_ID, setCartCount, null);
                    fetchDiamondDetail();
                    showToast({
                        title: "Success",
                        message: result.message || "Quantity updated in cart.",
                        type: "success"
                    });
                } else {
                    showToast({
                        title: "Warning",
                        message: result.message,
                        type: result.type || "warning",
                    });
                }
            }
        } catch (error) {
            console.error("Cart action error:", error);
            showToast({
                title: "Error",
                message: "An error occurred while updating your cart.",
                type: "error",
            });
        } finally {
            setIsProcessing(false);
        }
    };

    const handleUpdateWishlistBasketID = (styleId, newBasketID) => {
        setJewelleryData((prevData) => {
            if (!prevData || prevData.Style_ID !== styleId) return prevData;
            return {
                ...prevData,
                Wishlist_ID: newBasketID,
                IS_AddedInWishlist: newBasketID ? "YES" : "NO"
            };
        });
        setProduct((prevProduct) => {
            if (!prevProduct || prevProduct.Style_ID !== styleId) return prevProduct;
            return {
                ...prevProduct,
                Wishlist_ID: newBasketID,
                IS_AddedInWishlist: newBasketID ? "YES" : "NO"
            };
        });
        setProductItem((prev) => {
            if (!prev || prev.Style_ID !== styleId) return prev;
            return {
                ...prev,
                Wishlist_ID: newBasketID,
                IS_AddedInWishlist: newBasketID ? "YES" : "NO"
            };
        });
    };

    const handleUpdateWishlistBasketIDRecentView = (stockId, newBasketID) => {
        setRecentView((prevData) => {
            if (!prevData || !Array.isArray(prevData)) return prevData;
            const updatedData = prevData.map((item) =>
                item.STOCK_ID === stockId
                    ? { ...item, WishlistBasket_ID: newBasketID, IsWishlist: !!newBasketID }
                    : item
            );
            return JSON.stringify(updatedData) !== JSON.stringify(prevData) ? updatedData : prevData;
        });
    };

    const handleMouseMove = (e, index) => {
        const target = e.currentTarget;
        if (!isZoomVisible || !target) return;
        const rect = target.getBoundingClientRect();
        const zoomScale = 3;
        const overlayWidth = rect.width / zoomScale;
        const overlayHeight = rect.height / zoomScale;
        let x = e.clientX - rect.left - overlayWidth / 2;
        let y = e.clientY - rect.top - overlayHeight / 2;
        x = Math.max(0, Math.min(x, rect.width - overlayWidth));
        y = Math.max(0, Math.min(y, rect.height - overlayHeight));
        setHoverPosition({ x, y, width: overlayWidth, height: overlayHeight });
        setZoomStyles({
            backgroundSize: `${rect.width * zoomScale}px ${rect.height * zoomScale}px`,
            backgroundPosition: `-${x * zoomScale}px -${y * zoomScale}px`
        });
    };

    const handleMouseLeave = (index) => {
        setIsZoomVisible(false);
        setTimeout(() => {
            if (driftRef.current) {
                driftRef.current.destroy();
                driftRef.current = null;
            }
        }, 300);
    };

    const handleMediaClick = (index) => {
        if (product?.images) {
            const mediaList = product.images.map(img => ({ MEDIAURL: img }));
            setMediaItems(mediaList);
            setCurrentMediaIndex(index);
            setShowMediaModal(true);
        }
    };

    const handleVideoClick = (videoUrl) => {
        setMediaItems([{ MEDIAURL: videoUrl }]);
        setCurrentMediaIndex(0);
        setShowMediaModal(true);
    };

    const handleOpenQuickView = (product) => {
        setSelectedProductQuickView(product);
        setIsQuickViewOpen(true);
    };

    const handleCloseQuickView = () => {
        setSelectedProductQuickView(null);
        setIsQuickViewOpen(false);
    };
    // #endregion ZOOM DIAMOND IMAGE

    return (
        <>
            <div className="master-detail-page">
                <section className="vault-header-detail-card">
                    <div className="product-detail-header-left">
                        <h3 className="page-title">Style Inventory Detail</h3>
                    </div>
                    <div className="product-detail-header-right">
                        <div className="customer-wrapper">
                            <CustomerSelection />
                        </div>
                        <div className="header-actions">
                            <div className="action-icon-wrapper">
                                <Link to="/Wishlist" className="action-circle-container enquiry" title="Wishlist">
                                    <i className="pi pi-heart action-icon"></i>
                                    {wishlistCount > 0 && (
                                        <span className="action-badge enquiry-bg">{wishlistCount}</span>
                                    )}
                                </Link>
                            </div>
                            <div className="action-icon-wrapper">
                                <Link to="/StyleCart" className="action-circle-container cart" title="My Cart">
                                    <i className="pi pi-shopping-cart action-icon"></i>
                                    {cartCount > 0 && (
                                        <span className="action-badge cart-bg">{cartCount}</span>
                                    )}
                                </Link>
                            </div>
                        </div>
                        <button className="back-btn" onClick={() => navigate(-1)} aria-label="Go back">
                            <i className="pi pi-arrow-left"></i>
                        </button>
                    </div>
                </section>

                <section className="Vault-access-detail vault-header-card mt-3">
                    <div className="container-fluid">
                        <div className="row g-4">
                            <div className="col-lg-5 col-md-12">
                                <div className="diamond_carousel_section position-relative">
                                    <div id="carouselExampleCaptions" className="carousel slide shadow-sm rounded-4 overflow-hidden bg-light" data-bs-ride="carousel">
                                        <div className="carousel-inner">
                                            {product?.images?.length > 0 ? (
                                                product.images.map((img, index) => (
                                                    <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`} data-index={index}>
                                                        <div className="image-box d-flex align-items-center justify-content-center position-relative" style={{ background: '#fff' }}>
                                                            <img
                                                                src={img}
                                                                data-zoom={img}
                                                                className="d-block w-100 h-100"
                                                                alt={`Product Slide ${index + 1}`}
                                                                onClick={() => handleMediaClick(index)}
                                                                onMouseMove={(e) => handleMouseMove(e, index)}
                                                                onMouseEnter={(e) => {
                                                                    setIsZoomVisible(true);
                                                                    setActiveImageUrl(e.currentTarget.src);
                                                                }}
                                                                onMouseLeave={() => handleMouseLeave(index)}
                                                                style={{ objectFit: 'contain', padding: '20px' }}
                                                            />
                                                            {isZoomVisible && (
                                                                <div
                                                                    className="zoom-overlay"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: `${hoverPosition.x}px`,
                                                                        top: `${hoverPosition.y}px`,
                                                                        width: `${hoverPosition.width}px`,
                                                                        height: `${hoverPosition.height}px`,
                                                                        border: '2px solid rgba(0,0,0,0.3)',
                                                                        backgroundColor: 'rgba(255,255,255,0.2)',
                                                                        pointerEvents: 'none',
                                                                        zIndex: 10,
                                                                        boxShadow: '0 0 10px rgba(0,0,0,0.1)'
                                                                    }}
                                                                ></div>
                                                            )}
                                                            {product.NewArrivalStatus === "Yes" && (
                                                                <div className="position-absolute top-0 start-0 m-3">
                                                                    <span className="badge bg-primary px-3 py-2 rounded-pill">FRESH ARRIVAL</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="carousel-item active">
                                                    <div className="NoImg_box d-flex align-items-center justify-content-center" style={{ background: '#f8f9fa' }}>
                                                        <img src="/assets/images/VaultAccess/no-image3.png" alt="No Image Available" className="img-fluid opacity-50" />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {product?.images?.length > 1 && (
                                            <>
                                                <button className="carousel-control-prev custom-carousel-btn" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button className="carousel-control-next custom-carousel-btn" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                                <div className="carousel-indicators mb-0">
                                                    {product.images.map((_, index) => (
                                                        <button
                                                            key={index}
                                                            type="button"
                                                            data-bs-target="#carouselExampleCaptions"
                                                            data-bs-slide-to={index}
                                                            className={index === 0 ? "active" : ""}
                                                            style={{ backgroundColor: 'var(--brand-primary)', width: '10px', height: '10px', borderRadius: '50%' }}
                                                        />
                                                    ))}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    {isZoomVisible && (
                                        <div
                                            ref={zoomPaneRef}
                                            className="zoom-pane-container overflow-hidden border"
                                            style={{
                                                position: 'absolute',
                                                top: '0',
                                                left: '104%',
                                                width: '145%',
                                                height: '100%',
                                                zIndex: 2,
                                                backgroundImage: `url("${activeImageUrl}")`,
                                                backgroundRepeat: 'no-repeat',
                                                display: 'block',
                                                pointerEvents: 'none',
                                                backgroundColor: '#fff',
                                                ...zoomStyles
                                            }}
                                        ></div>
                                    )}
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-12">
                                <div className={`Product-Detail-section ${isZoomVisible ? 'invisible' : ''}`}>
                                    <div className="product-heading">
                                        <h3 className="fw-bold mb-2 d-flex align-items-center gap-2">
                                            <span className="product-name fw-bold">
                                                {product.Shortdescription || "Product Detail"}
                                            </span>
                                            {product.NewArrivalStatus === "Yes" && (
                                                <span className="badge badge-new-arrival"> FRESH ARRIVAL </span>
                                            )}
                                        </h3>
                                        <div className="master-library-detail-header">
                                            <h5 className="fw-bold me-2 mb-0 text-muted">Product Code:
                                                <span className="text-black"> {product.StyleNo} / {product.JewelCode}</span>
                                            </h5>
                                            <PriceValue
                                                lineAmount={product.LineAmount}
                                                priceRemark={product.PriceRemark}
                                            />
                                            <div className="action-buttons d-flex align-items-center">
                                                <div className="disclaimer_tooltip d-flex align-items-center">
                                                    <LuMessageCircleWarning size={24} className="text-muted" />
                                                    <Tooltip target=".disclaimer_tooltip" content="The price shown is approximate and may vary." position="top" />
                                                </div>
                                                <div className="share_btn">
                                                    <button onClick={handleShow} className="btn p-0 border-0 bg-transparent" title="Share">
                                                        <GrShareOption size={28} />
                                                    </button>
                                                </div>
                                                <div className="wishlist-button">
                                                    <WishListIcon size={31}
                                                        fill="var(--text-primary)"
                                                        onUpdateWishlistBasketID={handleUpdateWishlistBasketID}
                                                        onTransfer={handleTransferUpdate}
                                                        Style_ID={productItem.Style_ID}
                                                        JewelCode={productItem.JewelCode}
                                                        StyleNo={productItem.StyleNo}
                                                        Quantity={productItem.Quantity}
                                                        Cart_ID={productItem.Wishlist_ID}
                                                        iswishlist={isTrue(productItem.IS_AddedInWishlist) ? "YES" : "NO"}
                                                        isincart={isTrue(product.IS_AddedInCart) ? "YES" : "NO"}
                                                        ActualCart_ID={product.Cart_ID}
                                                        isProcessing={isProcessing}
                                                        setIsProcessing={setIsProcessing}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="Details-section mb-5">
                                        <h4 className="detail-heading fw-bold">Specifications</h4>
                                        <div className="row g-3">
                                            <div className="col-12 col-md-6 col-sm-12  detail-item">
                                                <b>Design Code:</b> <span>{product.Line1 || "-"}</span>
                                            </div>
                                            <div className="col-12 col-md-6 col-sm-12  detail-item">
                                                <b>Weight:</b> <span>{product.TotalNetWt} GM</span>
                                            </div>
                                            <div className="col-12 col-md-6 col-sm-12  detail-item">
                                                <b>SKU:</b> <span>{product.JewelCode}</span>
                                            </div>
                                            <div className="col-12 col-md-6 col-sm-12  detail-item">
                                                <b>Metal Type:</b> <span>{product.MetalQuality || "-"}</span>
                                            </div>
                                            <div className="col-12 col-md-6 col-sm-12  detail-item">
                                                <b>Item Size:</b> <span>{product.MaterialMMSize || "-"}</span>
                                            </div>
                                            <div className="col-12 col-md-6 col-sm-12  detail-item">
                                                <b>Diamond:</b> <span>{product.StoneQuality || "-"}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="action-buttons">
                                        <div className="count_inc_dec d-flex align-items-center rounded px-2 py-1">
                                            {productItem && (
                                                <HandelQuntityIncDec
                                                    qty={quantity}
                                                    initialQty={1}
                                                    unitPrice={productItem.LineAmount}
                                                    itemId={productItem.Stock_ID}
                                                    styleId={productItem.Style_ID}
                                                    updateQuantityInCart={(itemId, newQty) => { setQuantity(newQty); }}
                                                    decQuantityInCart={(itemId, newQty) => { setQuantity(newQty); }}
                                                />
                                            )}
                                        </div>
                                        <button
                                            className={`btn-cart-outline detail-cart${isTrue(product?.IS_AddedInCart) ? "btn-outline-cart" : ""}`}
                                            onClick={handleAddToCart}
                                        >
                                            {isTrue(product?.IS_AddedInCart) ? "IN CART (ADD MORE)" : "ADD TO CART"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row g-4 mt-2 align-items-start">
                            <div className="col-lg-6 col-md-12">
                                <div className="description-section mb-5">
                                    <h4 className="detail-heading fw-bold">Description</h4>
                                    <p className="text-muted" style={{ lineHeight: '1.6' }}>{product.Longdescription}</p>
                                </div>

                                <div className="tables-section">
                                    <div className="mb-4">
                                        <h4 className="detail-heading fw-bold">Metal Cost Guide</h4>
                                        <div className="table-responsive">
                                            <table className="table table-bordered custom-table">
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th>Metal</th>
                                                        <th>Weight</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr><td>Gold</td><td>{product.GrossWt || "-"}</td></tr>
                                                    <tr><td>Platinum</td><td>{product.PlatinumWeight || "-"}</td></tr>
                                                    <tr><td>Silver</td><td>{product.SilverWeight || "-"}</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <h4 className="detail-heading fw-bold">Diamond Specifications</h4>
                                        <div className="table-responsive">
                                            <table className="table table-bordered custom-table">
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th>Diamond</th>
                                                        <th>Carat</th>
                                                        <th>Pcs</th>
                                                        <th>Quality</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {product.DiaWt > 0 && (
                                                        <tr><td>White</td><td>{product.DiaWt}</td><td>{product.DiaPcs}</td><td>{product.StoneQuality || "-"}</td></tr>
                                                    )}
                                                    {product.CDiaWt > 0 && (
                                                        <tr><td>Color</td><td>{product.CDiaWt}</td><td>{product.CDiaPcs}</td><td>{product.StoneQuality || "-"}</td></tr>
                                                    )}
                                                    {materials
                                                        .filter(item => item.MaterialCategory?.toLowerCase().includes("diamond"))
                                                        .map((item, index) => (
                                                            <tr key={`diamond-${index}`}>
                                                                <td>{item.MaterialCategory}</td>
                                                                <td>{item.MaterialWeight || "-"}</td>
                                                                <td>{item.MaterialPcs || "-"}</td>
                                                                <td>{item.MaterialQuality || "-"}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-12 sticky-lg-top" style={{ top: '70px', zIndex: 1 }}>
                                {(jewelleryVideo?.length > 0 && jewelleryVideo.some(video => video.MEDIAURL)) ? (
                                    <div className="video-preview-section">
                                        <h4 className="detail-heading fw-bold">Product Video</h4>
                                        <div className="video-preview rounded-4 overflow-hidden shadow-sm bg-light">
                                            {jewelleryVideo.map((video, index) =>
                                                video.MEDIAURL ? (
                                                    <video
                                                        key={index}
                                                        className="w-100"
                                                        autoPlay loop muted playsInline
                                                        style={{ aspectRatio: '1 / 1', objectFit: 'contain', background: '#000' }}
                                                        onClick={() => handleVideoClick(video.MEDIAURL)}
                                                    >
                                                        <source src={video.MEDIAURL.replace(/\\/g, "/")} type="video/mp4" />
                                                    </video>
                                                ) : null
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="video-placeholder rounded-4 overflow-hidden shadow-sm bg-light d-flex align-items-center justify-content-center" style={{ aspectRatio: '1 / 1' }}>
                                        <div className="text-center text-muted">
                                            <i className="pi pi-video mb-2" style={{ fontSize: '2rem' }}></i>
                                            <p>No video available for this style</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {recentView && recentView.length > 0 && (
                            <div className="recently_viewed_section mt-5 pt-5 border-top">
                                <div className="d-flex align-items-center justify-content-between mb-4">
                                    <h2 className="fw-bold mb-0">Recently Viewed</h2>
                                </div>
                                <Card 
                                    ringData={recentView} 
                                    loading={loading} 
                                    showColorPalate={true} 
                                    onRecentViewUpdate={handleUpdateWishlistBasketIDRecentView} 
                                    onQuickViewOpen={handleOpenQuickView}
                                />
                            </div>
                        )}
                        <div className="diam_modal_container">
                            <ShareModal show={showModal} handleClose={handleClose} product={product} />
                        </div>
                    </div>
                </section>
                <QuickViewDialog 
                    visible={isQuickViewOpen} 
                    onHide={handleCloseQuickView} 
                    product={selectedProductQuickView} 
                    detailLinkPrefix="/detail?style_ID=" 
                />
            </div>
        </>
    )
}

const HandelQuntityIncDec = ({ qty, unitPrice, initialQty = 1, itemId, styleId, setTotalPrice, updateQuantityInCart, decQuantityInCart }) => {
    const [Qty, setQty] = useState(qty || initialQty);

    useEffect(() => {
        if (qty !== undefined) {
            setQty(qty);
        }
    }, [qty]);

    useEffect(() => {
        localStorage.setItem("num", Qty < 10 ? `0${Qty}` : `${Qty}`);
    }, [Qty]);

    const increment = () => {
        const currentQty = Number(Qty);
        const newQty = currentQty < 99 ? currentQty + 1 : currentQty;
        if (newQty !== currentQty) {
            setQty(newQty);
            if (updateQuantityInCart) {
                updateQuantityInCart(itemId, newQty, styleId, 1);
            }
        }
    };

    const decrement = () => {
        const currentQty = Number(Qty);
        const newQty = currentQty > 1 ? currentQty - 1 : currentQty;
        if (newQty !== currentQty) {
            setQty(newQty);
            if (updateQuantityInCart) {
                updateQuantityInCart(itemId, newQty, styleId, -1);
            }
        }
    };

    return (
        <>
            <button type="button" className="minus" onClick={decrement} style={{
                cursor: Qty <= 1 ? "not-allowed" : "pointer",
            }}>-</button>
            <div className="Qty">{Qty < 10 ? `${Qty}` : Qty}</div>
            <button type="button" className="plus" onClick={increment}>+</button>
        </>
    );
};

const ShareModal = ({ show, handleClose, product }) => {
    const [isShared, setIsShared] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState("viawhatsapp");
    const { user } = useAuth();
    const [copySuccess, setCopySuccess] = useState(false);

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        } catch (err) {
            console.error("Failed to copy link:", err);
        }
    };

    const handleShare = async (e) => {
        e.preventDefault();

        if (selectedOption === "viawhatsapp") {
            const phoneNumber = document.getElementById("Share_number")?.value.trim();
            if (!phoneNumber || phoneNumber.length < 10 || isNaN(phoneNumber)) {
                alert("Please enter a valid 10-digit mobile number");
                return;
            }
            const currentUrl = encodeURIComponent(window.location.href);
            const whatsappUrl = `https://wa.me/${phoneNumber}?text=Check%20out%20this%20link:%20${currentUrl}`;
            window.open(whatsappUrl, "_blank");
            setIsShared(true);
        } else if (selectedOption === "viaemail") {
            const email = document.getElementById("Share_email")?.value.trim();
            if (!email || !/\S+@\S+\.\S+/.test(email)) {
                alert("Please enter a valid email address");
                return;
            }

            try {
                setIsLoading(true);
                const requestParameter = JSON.stringify({
                    Party_ID: user?.SelectedCustomer_ID || "0",
                    EmailID: email,
                    ProductURL: window.location.href,
                });
                const response = await ShareProductData(requestParameter);
                setIsShared(true);
            } catch (error) {
                console.error("Error sharing product via email:", error);
                alert("Failed to share product via email. Please try again.");
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleBack = () => {
        setIsShared(false);
        setSelectedOption("viawhatsapp");
    };

    if (!show) return null;

    return (
        <div className="premium-share-modal-overlay">
            <div className="premium-share-modal-card">
                <div className="premium-share-modal-header">
                    <h3 className="modal-title">Share Product</h3>
                    <button className="premium-close-btn" onClick={handleClose} aria-label="Close">
                        <i className="pi pi-times" />
                    </button>
                </div>

                {!isShared ? (
                    <div className="premium-share-modal-body">
                        <div className="share-channel-tabs">
                            <button
                                type="button"
                                className={`channel-tab whatsapp-tab ${selectedOption === "viawhatsapp" ? "active" : ""}`}
                                onClick={() => setSelectedOption("viawhatsapp")}
                            >
                                <div className="channel-icon-wrapper">
                                    <i className="pi pi-whatsapp" />
                                </div>
                                <span>WhatsApp</span>
                            </button>
                            <button
                                type="button"
                                className={`channel-tab email-tab ${selectedOption === "viaemail" ? "active" : ""}`}
                                onClick={() => setSelectedOption("viaemail")}
                            >
                                <div className="channel-icon-wrapper">
                                    <i className="pi pi-envelope" />
                                </div>
                                <span>Email</span>
                            </button>
                        </div>

                        <div className="share-form-content">
                            <form onSubmit={handleShare}>
                                {selectedOption === "viawhatsapp" ? (
                                    <div className="share-input-group">
                                        <label htmlFor="Share_number" className="share-input-label">Mobile Number</label>
                                        <div className="share-input-wrapper">
                                            <i className="pi pi-phone input-icon" />
                                            <input
                                                type="tel"
                                                id="Share_number"
                                                maxLength="10"
                                                className="share-input-field"
                                                placeholder="Enter 10-digit mobile number"
                                                required
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="share-input-group">
                                        <label htmlFor="Share_email" className="share-input-label">Email Address</label>
                                        <div className="share-input-wrapper">
                                            <i className="pi pi-envelope input-icon" />
                                            <input
                                                type="email"
                                                id="Share_email"
                                                className="share-input-field"
                                                placeholder="Enter recipient's email"
                                                required
                                            />
                                        </div>
                                    </div>
                                )}

                                <button type="submit" className="premium-share-submit-btn" disabled={isLoading}>
                                    {isLoading ? (
                                        <>
                                            <i className="pi pi-spin pi-spinner me-2" />
                                            Sharing...
                                        </>
                                    ) : (
                                        <>
                                            <i className={`pi ${selectedOption === "viawhatsapp" ? "pi-whatsapp" : "pi-send"} me-2`} />
                                            Share Product
                                        </>
                                    )}
                                </button>
                            </form>
                        </div>

                        <div className="share-modal-divider">
                            <span>or</span>
                        </div>

                        <div className="share-copy-link-section">
                            <div className="share-link-preview-box">
                                <span className="share-link-text">{window.location.href}</span>
                            </div>
                            <button
                                type="button"
                                className={`share-copy-btn ${copySuccess ? "copied" : ""}`}
                                onClick={handleCopyLink}
                            >
                                <i className={`pi ${copySuccess ? "pi-check" : "pi-copy"}`} />
                                <span>{copySuccess ? "Copied" : "Copy"}</span>
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="premium-share-success-body">
                        <div className="success-icon-animation">
                            <div className="success-circle">
                                <i className="pi pi-check" />
                            </div>
                        </div>
                        <h4 className="success-title">Successfully Shared!</h4>
                        <p className="success-message">
                            {selectedOption === "viawhatsapp"
                                ? "Product link was opened in WhatsApp."
                                : "Product link has been sent to the email address successfully."}
                        </p>
                        <div className="success-actions">
                            <button type="button" className="btn-secondary-outline" onClick={handleBack}>
                                <i className="pi pi-arrow-left me-2" />
                                Share Again
                            </button>
                            <button type="button" className="btn-primary" onClick={handleClose}>
                                Done
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StyleJewelleryDetail;
export { HandelQuntityIncDec };
